import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RedirectGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.url.length > 0 && route.url[0].path === 'flexipay') {
      const url = route.url.map(segment => segment.path).join('/');
      window.location.href = './' + url + (route.url.length === 1 ? '/' : '');
      return false;
    }

    return true;
  }
}
